import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Heading,
  Stack,
  StackDivider,
  Box,
  Text,
  Image,
  Divider,
  ButtonGroup,
  Button,
  Wrap,
  Center,
  Flex,
  Spacer,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserBanner } from './User.js';
import { Rating } from './Rating.js';
import moment from 'moment';

export function ServiceCard({
  id,
  title,
  description,
  price,
  image_url,
  rating,
  total_ratings,
  completed_count,
  user_id,
  user_img,
  user_name,
  user_rating,
  user_total_ratings,
  avg_completion_time,
}) {
  let navigate = useNavigate();
  return (
    <Card maxW="300px" onClick={() => navigate('/service/' + id)}>
      <CardBody p={0}>
        <Image src={image_url} borderRadius="sm" h={200} w={300} />

        <Stack mt="3" spacing="1" m="2">
          {user_name ? (
            <UserBanner
              {...{
                user_id,
                user_img,
                user_name,
                user_rating,
                user_total_ratings,
              }}
            />
          ) : null}

          <Heading size="sm" textAlign={'left'}>
            {title}
          </Heading>
          <Rating value={rating} total={total_ratings} />
          <Stack align="baseline" mt="0" spacing="0">
            <Box fontSize="12px" color="gray.400">
              {completed_count} successful gigs with average time of{' '}
              {moment.duration(avg_completion_time, 'seconds').humanize()}
            </Box>
          </Stack>
        </Stack>
      </CardBody>
      <Box p="2" pb="2">
        <Flex>
          <Spacer />
          {/* <ButtonGroup>
              <Button variant="solid" colorScheme="green" size="sm"> */}
          {(price / 1000).toFixed(2)} GIG
          {/* </Button>
            </ButtonGroup> */}
        </Flex>
      </Box>
    </Card>
  );
}
